import { render, staticRenderFns } from "./delivery-list.vue?vue&type=template&id=4940312b&scoped=true"
import script from "./delivery-list.vue?vue&type=script&lang=js"
export * from "./delivery-list.vue?vue&type=script&lang=js"
import style0 from "./delivery-list.vue?vue&type=style&index=0&id=4940312b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940312b",
  null
  
)

export default component.exports